import { render } from "./InfoView.vue?vue&type=template&id=9ab0e31c&scoped=true"
import script from "./InfoView.vue?vue&type=script&lang=js"
export * from "./InfoView.vue?vue&type=script&lang=js"

import "./InfoView.vue?vue&type=style&index=0&id=9ab0e31c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ab0e31c"]])

export default __exports__